export default "__VITE_ASSET__NcDihOxq__";